module.exports = __webpack_public_path__ + "img/client-1.dbf40197.png";